import { Select } from '@a0/quantum-product';
import React from 'react';
import { mapOptionTypes } from '../../util/clientTypesHelper';
var SelectClient = function (_a) {
    var _b;
    var clients = _a.clients, clientsByType = _a.clientsByType, selectedClientId = _a.selectedClientId, handleClientChange = _a.handleClientChange;
    return (React.createElement(Select, { onChange: function (event) { return handleClientChange(event.target.value); }, value: (_b = clients.find(function (client) { return client.client_id === selectedClientId; })) === null || _b === void 0 ? void 0 : _b.client_id }, mapOptionTypes(clientsByType)));
};
export default SelectClient;
